module.exports = __webpack_public_path__ + "static/media/Uruguay_Korea.9d27e7a4.jpeg";